import type {SxProps} from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type {FC, ReactNode} from 'react';

//TYPES
type Props = {
  value: string;
  direction?: 'column' | 'row';
  required?: boolean;
  children?: ReactNode;
};

const Label: FC<Props> = ({value, children, direction = 'column', required = false}) => {
  return (
    <Stack direction="column" sx={styles.container}>
      <Typography variant="overline" sx={styles.label}>
        {value} {required && '*'}
      </Typography>
      <Stack direction={direction} sx={styles.childContainer}>
        {children}
      </Stack>
    </Stack>
  );
};

export default Label;

const styles: Record<string, SxProps> = {
  container: {
    display: 'flex',
    width: '100%',
  },
  childContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: 1,
  },
  label: {
    ml: 0.5,
    color: 'primary.main',
    fontWeight: 'bold',
  },
};
